// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".square-btn[data-v-6757351b]{border-radius:6px}.widget-img[data-v-6757351b]{height:68px;width:auto}@media (min-width:1264px){.widget-img[data-v-6757351b]{height:100px}}.balance[data-v-6757351b]{min-height:84px}@media (min-width:1264px){.balance[data-v-6757351b]{min-height:116px}}.center-align[data-v-6757351b]{width:50%;text-align:center}", ""]);
// Exports
module.exports = exports;
